import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
import { FontWeight } from "../../foundations/typography.es.js";
import { isFunction } from "../../utils/type-checking/type-checking.es.js";
import { styledOptions } from "../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import { memo } from "react";
import MuiLink from "../../../node_modules/@mui/material/Link/Link.es.js";
import { Text } from "../../foundations/palette.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
import { CursorStyle } from "../../foundations/cursor-style.es.js";
import { Typography } from "../typography/typography.es.js";
const CustomBreadcrumbsLink = styled(MuiLink, styledOptions)(({
  theme,
  active
}) => ({
  display: Displaying.flex,
  alignItems: Alignment.center,
  gap: theme.spacing(2),
  color: active ? theme.palette.text.secondary : Displaying.inherit,
  fontWeight: active ? FontWeight.bold : FontWeight.normal
}));
function BreadcrumbsLinkBuilder({
  children,
  lastElement,
  onClick,
  href,
  sx,
  ...rest
}) {
  const isClickable = isFunction(onClick) || href;
  const onHoverTextDecoration = isClickable ? "hover" : Displaying.none;
  const cursorStyle = isClickable ? CursorStyle.pointer : CursorStyle.default;
  if (lastElement) {
    return /* @__PURE__ */ jsx(Typography, { noWrap: true, textOverflow: "ellipsis", overflow: "hidden", color: Text.secondary, fontWeight: FontWeight.bold, onClick, sx: {
      cursor: cursorStyle,
      ...sx
    }, ...rest, children });
  } else {
    return /* @__PURE__ */ jsx(CustomBreadcrumbsLink, { sx: {
      cursor: cursorStyle,
      ...sx
    }, underline: onHoverTextDecoration, href, onClick, ...rest, children });
  }
}
const BreadcrumbsLink = memo(BreadcrumbsLinkBuilder);
export {
  BreadcrumbsLink
};
//# sourceMappingURL=breadcrumbs-link.es.js.map
